const MAX_TIMEOUT_MS = 2147483647;

/**
 * Safely executes setTimeout with support for delays greater than 2,147,483,647 ms.
 * For every new timeout in the chain, calls onActiveTimeoutId with the current timeout id.
 *
 * @param {Function} callback - The function to execute after the delay.
 * @param {number} ms - The delay in milliseconds (can exceed MAX_TIMEOUT_MS).
 * @param {Function} onActiveTimeoutId - Callback invoked with the timeout id of each setTimeout as it is created.
 */
export function safeSetTimeout(callback, ms, onActiveTimeoutId) {
    const timeoutId =
        ms > MAX_TIMEOUT_MS
            ? setTimeout(() => {
                  safeSetTimeout(callback, ms - MAX_TIMEOUT_MS, onActiveTimeoutId);
              }, MAX_TIMEOUT_MS)
            : setTimeout(callback, ms);

    onActiveTimeoutId(timeoutId);
}
